const getParsedFee = ({ fee }) => {
    if (fee === null)
        return '';
    return `$${fee.toLocaleString()}`;
};
export class TimeSlotFeeDataForDetailConfirmationPage {
    #timeSlotFeeData;
    #timeSlotCount;
    constructor({ timeSlotFeeData, timeSlotCount, }) {
        this.#timeSlotFeeData = timeSlotFeeData;
        this.#timeSlotCount = timeSlotCount;
    }
    get parsedDailyServiceFee() {
        const dailyServiceFee = this.#timeSlotFeeData.dailyServiceFee;
        return getParsedFee({ fee: dailyServiceFee });
    }
    get parsedDailyPlatformFee() {
        const dailyPlatformFee = this.#timeSlotFeeData.dailyPlatformFee;
        return getParsedFee({ fee: dailyPlatformFee });
    }
    get parsedDailyFee() {
        const dailyFee = this.#timeSlotFeeData.dailyFee;
        return getParsedFee({ fee: dailyFee });
    }
    get parsedExtraChargeItemList() {
        const extraChargeItemList = this.#timeSlotFeeData.extraChargeItemList;
        const parsedExtraChargeItemList = extraChargeItemList.join('、');
        return parsedExtraChargeItemList;
    }
    get parsedExpectedTotalFee() {
        const expectedTotalFee = this.#timeSlotFeeData.expectedTotalFee;
        return getParsedFee({ fee: expectedTotalFee });
    }
    get parsedSummedExpectedTotalServiceFee() {
        const expectedTotalServiceFee = this.#timeSlotFeeData.expectedTotalServiceFee;
        const summedExpectedTotalServiceFee = expectedTotalServiceFee * this.#timeSlotCount;
        return getParsedFee({ fee: summedExpectedTotalServiceFee });
    }
    get parsedSummedExpectedTotalPlatformFee() {
        const expectedTotalPlatformFee = this.#timeSlotFeeData.expectedTotalPlatformFee;
        const summedExpectedTotalPlatformFee = expectedTotalPlatformFee * this.#timeSlotCount;
        return getParsedFee({ fee: summedExpectedTotalPlatformFee });
    }
    get parsedSummedExpectedTotalFee() {
        const expectedTotalFee = this.#timeSlotFeeData.expectedTotalFee;
        const summedExpectedTotalFee = expectedTotalFee * this.#timeSlotCount;
        return getParsedFee({ fee: summedExpectedTotalFee });
    }
}
